import { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'

import { Element, AlignableElement } from '@src/mixins/element/element'
import { Alignable } from '@src/mixins/alignable/alignable'

import './link.sass'

@Component
export class Link extends Mixins<AlignableElement>(Element, Alignable) {

  render (h: CreateElement) {
    let styleClasses = [
      ...this.elementStyles,
      ...this.alignableStyles,
      ...this.linkStyles
    ]

    return (
      this.renderElement(h, styleClasses, this.disabled, [
        this.renderLabel(h)
      ])
    )
  }

  protected get linkStyles () {
    return ['link']
  }

}
